import { isFunction } from 'lodash/fp';

export const divTableSortDirections = {
  asc: 'asc',
  desc: 'desc',
} as const;
export type DivTableSortDirection = (typeof divTableSortDirections)[keyof typeof divTableSortDirections];

type SortFn<T> = (a: T, b: T) => number;

export class Column {
  public sortDirection: DivTableSortDirection;

  constructor(
    public title,
    public titleClass = '',
    public columnClass = '',
    public sortFunction: null | ((a, b) => number) = null,
    public sorted = false,
    sortDirection?: DivTableSortDirection,
    public colspan?: number,
  ) {
    this.sortDirection = sortDirection ?? divTableSortDirections.asc;

    if (isFunction(sortFunction) || sortFunction === null) {
      this.sortFunction = sortFunction;
    } else {
      this.sortFunction = (a, b) => {
        if (a[sortFunction] > b[sortFunction]) {
          return 1;
        }

        return a[sortFunction] < b[sortFunction] ? -1 : 0;
      };
    }
  }
}

export const createColumnInstance = <F>({
  title,
  columnClass = '',
  titleClass = '',
  sortFunction = null,
  sorted = false,
  sortDirection = divTableSortDirections.asc,
  colspan,
}: {
  title: string;
  columnClass?: string;
  titleClass?: string;
  sortFunction?: null | ((a: F, b: F) => number);
  sorted?: boolean;
  sortDirection?: DivTableSortDirection;
  colspan?: number;
}) => new Column(title, titleClass, columnClass, sortFunction, sorted, sortDirection, colspan);

export class DivTableColumn<T> {
  public sortDirection: DivTableSortDirection;

  constructor(
    public title: string,
    public columnClass: string,
    public sortFunction: SortFn<T>,
    // eslint-disable-next-line @typescript-eslint/default-param-last
    public sorted = false,
    public hidden: boolean,
    sortDirection?: DivTableSortDirection,
    public sortable = true,
  ) {
    this.sortDirection = sortDirection ?? divTableSortDirections.asc;
  }
}

export const createDivTableColumnInstance = <T>({
  title,
  columnClass,
  sortFunction,
  sorted,
  sortDirection,
  hidden,
  sortable = true,
}: {
  title: string;
  columnClass: string;
  sortFunction: SortFn<T>;
  sorted: boolean;
  sortDirection?: DivTableSortDirection;
  hidden: boolean;
  sortable?: boolean;
}) => new DivTableColumn<T>(title, columnClass, sortFunction, sorted, hidden, sortDirection, sortable);
